import AdminHeader from '../components/common/AdminHeader';
import PaymentList from '@/components/masters/PaymentList';

export default function PaymentListPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      <main className="max-w-full mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <PaymentList />
      </main>
    </div>
  );
}
